import {
  GET_SESSION_SAGA,
  LOGOUT_USER_SAGA,
  GET_ADMIN_SESSION_SAGA,
  LOGOUT_ADMIN_SAGA,
} from './types';

export const getSession = () => ({
  type: GET_SESSION_SAGA,
});

export const logoutUser = () => ({
  type: LOGOUT_USER_SAGA,
});

export const getAdminSession = () => ({
  type: GET_ADMIN_SESSION_SAGA,
});

export const logoutAdmin = () => ({
  type: LOGOUT_ADMIN_SAGA,
});
